import { render, staticRenderFns } from "./pricingGpt1.vue?vue&type=template&id=0d53acac&scoped=true&"
import script from "./pricingGpt1.vue?vue&type=script&lang=js&"
export * from "./pricingGpt1.vue?vue&type=script&lang=js&"
import style0 from "./pricingGpt1.vue?vue&type=style&index=0&id=0d53acac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d53acac",
  null
  
)

export default component.exports